import * as _ from 'lodash';
import { FormState } from 'redux-form';

export function didSubmitSuccessfully(formData: FormState): boolean {
  return formData && !_.isNil(formData.submitFailed) && !formData.submitFailed;
}

export function isFormSubmitting(formData: FormState): boolean {
  return formData && formData.submitting;
}

export function isFormOpen(formData: FormState): boolean {
  return !!formData;
}
